import { render, staticRenderFns } from "./StatisticsWdTurnoverWd.vue?vue&type=template&id=0ddef3b4&scoped=true&"
import script from "./StatisticsWdTurnoverWd.vue?vue&type=script&lang=js&"
export * from "./StatisticsWdTurnoverWd.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsWdTurnoverWd.vue?vue&type=style&index=0&id=0ddef3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddef3b4",
  null
  
)

export default component.exports